import React from 'react';
import s from './Hero.module.css';
import LoadingSpinner from '../LoadingSpinner/LoadingSpinner';

export default function Hero({data}) {

    if(!Object.keys(data).length){
        return (
            <header className={s.section}>
                <LoadingSpinner/>
            </header>
        )
    }

    return (
        <section className={s.section} id="Propuesta">
            <div className={s.content}>
                <h3>{data.nombre}</h3>
                <div dangerouslySetInnerHTML={{ __html: data.cuerpo }} />
                    <div className={s.contactoBtn} onClick={()=>{window.scrollTo(0, document.getElementById("Contacto").offsetTop-120);}}>
                        <p>CONTACTANOS</p>
                    </div>
            </div>
            <img src={`http://peuma-ig.com.ar/admin/${data.imagen}`} alt='gif'/>
        </section>
  )
}
